module.exports = __webpack_public_path__ + "img/20190924154110360截图20190924145828185.4824949f.jpg";